export default () => ({
    isBlocked: false,
});